import { isNil } from 'lodash';
import { Actions, ActionTypes } from './helper.actions';
import { EventSeriesModel, ZipCodeCities } from './helper.interface';

export interface State {
  allCountries: Array<string>;
  supportedLanguages: Array<string>;
  activeLanguage: string;
  apiCallResult: any;
  selfRegistration: boolean;
  isEventSeriesPage: EventSeriesModel;
  isWidget: boolean;
  modalIframeUrl: string;
  spinnerValue: boolean;
  citiesByZipcode: ZipCodeCities[];
  reloadRequired: boolean;
  isLogoutProcessing: boolean;
  initializeConteoLogin: boolean;
  reinitializeConteoLogin: boolean;
  latestInitializedConteoLoginExhibitionId: number;
}

export const initialState: State = {
  allCountries: null,
  supportedLanguages: [],
  activeLanguage: '',
  apiCallResult: null,
  selfRegistration: false,
  isEventSeriesPage: null,
  isWidget: false,
  modalIframeUrl: null,
  spinnerValue: false,
  citiesByZipcode: [],
  reloadRequired: false,
  isLogoutProcessing: false,
  initializeConteoLogin: false,
  reinitializeConteoLogin: false,
  latestInitializedConteoLoginExhibitionId: null
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.ADD_ALL_COUNTRIES_TO_LIST: {
      const allCountries = action.payload;
      return {
        ...state,
        allCountries: allCountries
      };
    }

    case ActionTypes.SET_SELF_REGISTRATION: {
      const registration = action.payload;
      return {
        ...state,
        selfRegistration: registration
      };
    }

    case ActionTypes.SET_EVENT_SERIES_PAGE: {
      const eventSeriesPage = action.payload;
      return {
        ...state,
        isEventSeriesPage: eventSeriesPage
      };
    }

    case ActionTypes.SET_IS_WIDGET: {
      const isWidget = action.payload;
      return {
        ...state,
        isWidget
      };
    }

    case ActionTypes.SET_API_CALL_RESULT: {
      const apiCallResult = action.payload;
      return {
        ...state,
        apiCallResult: apiCallResult
      };
    }

    case ActionTypes.SET_ACTIVE_LANGUAGE: {
      const activeLanguage = action.payload;
      return {
        ...state,
        activeLanguage: activeLanguage
      };
    }

    case ActionTypes.SET_SUPPORTED_LANGUAGES: {
      const supportedLanguages = action.payload;
      return {
        ...state,
        supportedLanguages: supportedLanguages
      };
    }

    case ActionTypes.SET_SPINNER_VALUE: {
      const spinnerValue = action.payload;
      return {
        ...state,
        spinnerValue
      };
    }

    case ActionTypes.SET_RELOAD_REQUIRED: {
      const reloadRequired = action.payload;
      return {
        ...state,
        reloadRequired
      };
    }

    case ActionTypes.SET_IS_LOGOUT_PROCESSING: {
      const isLogoutProcessing = action.payload;

      return {
        ...state,
        isLogoutProcessing
      };
    }

    case ActionTypes.SET_INITIALIZE_CONTEO_LOGIN: {
      const initializeConteoLogin = action.payload;

      return {
        ...state,
        initializeConteoLogin
      };
    }

    case ActionTypes.SET_REINITIALIZE_CONTEO_LOGIN: {
      const reinitializeConteoLogin = action.payload;

      return {
        ...state,
        reinitializeConteoLogin
      };
    }

    case ActionTypes.SET_LATEST_INITIALIZED_CONTEO_LOGIN_EXHIBITION_ID: {
      const exhibitionId = !isNil(action.payload) ? +action.payload : null;

      return {
        ...state,
        latestInitializedConteoLoginExhibitionId: exhibitionId
      };
    }

    case ActionTypes.RESET_REDUCER: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}

/**
 * Because the data structure is defined within the reducer it is optimal to
 * locate our selector functions at this level. If store is to be thought of
 * as a database, and reducers the tables, selectors can be considered the
 * queries into said database. Remember to keep your selectors small and
 * focused so they can be combined and composed to fit each particular
 * use-case.
 */

export const getAllCountries = (state: State) => state.allCountries;
export const getLanguage = (state: State) => state.activeLanguage;
export const getSupportedLanguages = (state: State) => state.supportedLanguages;
export const getSelfRegistration = (state: State) => state.selfRegistration;
export const isEventSeriesPage = (state: State) => state.isEventSeriesPage;
export const getIsWidget = (state: State) => state.isWidget;
export const getSpinnerValue = (state: State) => state.spinnerValue;
export const getAllCitiesByZipCode = (state: State) => state.citiesByZipcode;
export const getReloadRequired = (state: State) => state.reloadRequired;
export const selectIsLogoutProcessing = (state: State) => state.isLogoutProcessing;
export const selectInitializeConteoLogin = (state: State) => state.initializeConteoLogin;
export const selectReinitializeConteoLogin = (state: State) => state.reinitializeConteoLogin;
export const selectLatestInitializedConteoLoginExhibitionId = (state: State) =>
  state.latestInitializedConteoLoginExhibitionId;
